import React, { Component } from 'react';
import {
    Link, withRouter
} from 'react-router-dom';
import activateImg from '../../images/activateimg.jpg'
import manageImg from '../../images/manageimg.jpg'
import customerImg from '../../images/customerimg.jpg'
import Signin from '../register/signin.jsx'
import $ from 'jquery'
import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux';

const mapStateToProps = state =>
    ({
        managestate:state.Manage.managestate
    })

const mapDispatchToProps = dispatch =>
    ({
        fetchManageInform(managestate) {
            dispatch(
                actions.ManageAction(managestate)
            )
        }
    })
class componentName extends Component {
    constructor(props) {
        super(props);
        this.state = {
            managestate:false
        };
        this.handleshowdiv = this.handleshowdiv.bind(this)
    }
    componentWillMount(){
        $('html,body').scrollTop(0);
    }
    handleshowdiv(){
        let _this = this
        this.setState({
            managestate: true
        }, () => {
           
            _this.props.fetchManageInform(this.state.managestate)
            $('html,body').scrollTop(0);
        }
    
    )   
   
   }
   
    render() {
        const{managestate} = this.state
        return (
            <div>
                <div className="row " >
                    <div className="col-md-12 home-desc" >
                        <section className="row" id="features" style={{ padding: "15px 0px" }}>
                            <div className="col-lg-4 col-md-4 col-sm-12 bg-white text-dark">
                                <div className="p-5 text-center wow zoomIn" data-wow-delay=".1s">
                                    <img src={activateImg} alt='activate' />
                                    <div className="h5 mt-3">Cardholder Benefits</div>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>Accessible Anywhere</p>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>Worldwide Visa Acceptance - 24,000,000+ locations</p>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>Secure Online Shopping</p>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>Use in Australia and Overseas</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 bg-grey text-dark">
                            
                                <div className="p-5 text-center wow zoomIn" data-wow-delay=".3s">
                                    <img src={manageImg} alt='manage' />
                                    <div className="h5 mt-3">Manage Your Account </div>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>Check Your Card Account Balance</p>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>View Your Transaction History</p>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>Set and/or Change Your PIN</p>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>Update Your Personal Details</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 bg-white text-dark">
                                <div className="p-5 text-center wow zoomIn" data-wow-delay=".5s">
                                    <img src={customerImg} alt='Customer' />
                                    <div className="h5 mt-3"> Customer Support</div>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>24-7 Online Access</p>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>24-7 Telephone Support - 1800 914 332</p>
                                    <p className="mt-1" style={{ margin: "0 0 0px" }}>Email Customer Service</p>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(componentName));


// WEBPACK FOOTER //
// ./src/components/description/description.jsx